type LocationLike = Pick<Location, "origin" | "pathname" | "hash">

type RouterHistoryMode = "hash" | "html5" | string | undefined

const LOGIN_PATH = "/login"
const HASH_LOGIN_PATH = "#/login"

function normalizePathname(pathname: string) {
  if (!pathname) return "/"
  const normalized = pathname.startsWith("/") ? pathname : `/${pathname}`
  return normalized.replace(/\/+$/, "") || "/"
}

function isStaticLoginPath(pathname: string) {
  const normalized = normalizePathname(pathname)
  return normalized === LOGIN_PATH || normalized.endsWith(LOGIN_PATH)
}

function normalizeRouterHistoryMode(routerHistory: RouterHistoryMode) {
  return typeof routerHistory === "string"
    ? routerHistory.trim().replace(/^['"]|['"]$/g, "").toLowerCase()
    : ""
}

function isHashRouterDeployment(locationLike: Pick<LocationLike, "hash">, routerHistory: RouterHistoryMode) {
  const normalizedMode = normalizeRouterHistoryMode(routerHistory)
  if (normalizedMode === "hash") return true
  if (normalizedMode === "html5" || normalizedMode === "history") return false
  return locationLike.hash.startsWith("#/")
}

function normalizeBasePath(pathname: string) {
  const normalized = normalizePathname(pathname)
  if (normalized === "/" || normalized === LOGIN_PATH) return "/"
  if (normalized.endsWith(LOGIN_PATH)) {
    return `${normalized.slice(0, -LOGIN_PATH.length) || ""}/`
  }
  return `${normalized}/`
}

export function resolveLoginRedirectUrl(
  locationLike: LocationLike = window.location,
  routerHistory: RouterHistoryMode = import.meta.env.VITE_ROUTER_HISTORY,
) {
  if (isHashRouterDeployment(locationLike, routerHistory)) {
    return `${locationLike.origin}${normalizeBasePath(locationLike.pathname)}${HASH_LOGIN_PATH}`
  }
  return LOGIN_PATH
}

export function shouldRedirectToLogin(
  locationLike: Pick<Location, "pathname" | "hash"> = window.location,
  routerHistory: RouterHistoryMode = import.meta.env.VITE_ROUTER_HISTORY,
) {
  if (isHashRouterDeployment(locationLike, routerHistory)) {
    return locationLike.hash !== HASH_LOGIN_PATH || isStaticLoginPath(locationLike.pathname)
  }
  return locationLike.pathname !== LOGIN_PATH
}

export function replaceToLogin() {
  if (shouldRedirectToLogin()) {
    location.replace(resolveLoginRedirectUrl())
  }
}
